<template>
  <div class="vdw-force-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>V(r) = 4ε[(σ/r)¹² - (σ/r)⁶] | Lennard-Jones势$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- LJ Potential Graph -->
          <g transform="translate(50, 200)">
             <line x1="0" y1="0" x2="300" y2="0" stroke="#888" />
             <line x1="0" y1="20" x2="0" y2="-180" stroke="#888" />
             <text x="310" y="5" fill="#888" font-size="8">距离 r</text>
             <text x="-35" y="-170" fill="#888" font-size="8">势能 V</text>

             <path :d="ljPath" fill="none" stroke="#2ed573" stroke-width="2" />
             
             <!-- Equilibrium marker -->
             <circle cx="60" cy="15" r="4" fill="#ff4757" />
             <text x="70" y="25" fill="#ff4757" font-size="8">最稳定距离 (r₀)</text>
          </g>

          <!-- Interacting atoms -->
          <g transform="translate(250, 60)">
             <!-- Atom 1 (Fixed) -->
             <circle cx="0" cy="0" r="15" fill="rgba(0, 210, 255, 0.4)" stroke="#00d2ff" />
             <circle v-for="n in 3" :key="n" :cx="Math.cos(time+n)*10" :cy="Math.sin(time+n)*10" r="2" fill="#fff" />
             
             <!-- Atom 2 (Moving) -->
             <g :transform="`translate(${dist}, 0)`">
                <circle cx="0" cy="0" r="15" fill="rgba(0, 210, 255, 0.4)" stroke="#00d2ff" />
                <circle v-for="n in 3" :key="'b'+n" :cx="Math.cos(time+n+1)*10" :cy="Math.sin(time+n+1)*10" r="2" fill="#fff" />
             </g>

             <!-- Attraction indicator -->
             <path v-if="dist > 40" :d="`M 20,0 L ${dist-20},0`" stroke="#ffd700" stroke-dasharray="2,2" :stroke-width="100/dist" />
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>作用力类型: {{ dist < 40 ? '电子云重叠斥力 (1/r¹²)' : '瞬时偶极吸引力 (1/r⁶)' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节分子距离 r</label>
             <el-slider v-model="dist" :min="20" :max="150" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>范德华力是存在于分子间的一种弱相互作用力。它起源于原子内部电子运动产生的**瞬时偶极**诱导出的吸引力。根据Lennard-Jones势模型，分子在中长距离表现为吸引力（与r⁻⁶成正比），而当距离缩短到电子云发生重叠时，由于泡利不相容原理会产生极其强烈的斥力（与r⁻¹²成正比）。它是决定物质相态变化（如气体液化）的关键力量。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VanDerWaalsForceViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      dist: 80,
      time: 0
    }
  },
  computed: {
    ljPath() {
       let d = "M 5 0 ";
       for (let x = 15; x <= 300; x += 2) {
          let r = x / 60;
          let v = 4 * (Math.pow(1/r, 12) - Math.pow(1/r, 6));
          d += `L ${x} ${Math.min(v * 20, 20)} `;
       }
       return d;
    }
  },
  methods: {
    update() {
       this.time += 0.1;
       requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
.vdw-force-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(46, 213, 115, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
